import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { RootState } from 'store';

import Loader from 'components/Loader';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { getCompanyLineCredit } from 'services/paymentMethodService';

import NavigationList from './NavigationList';
import { Container, Content, Subtitle } from './styles';
import SubMenuHeader from './SubMenuHeader';
import { CloseButton, CloseIcon } from 'components/ModalHeader/styles';

export interface MenuItem {
  name: string;
  show: boolean;
  onClick: () => void;
}

const ResellerCompany = () => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const accountResult = useSelector((state: RootState) => state.user.accountResult);
  const [loading, setLoading] = useState(true);
  const [hasLineCredit, setHasLineCredit] = useState(false);
  const renderHeader = () => <SubMenuHeader onClose={() => history.replace('/corporate/billingCompanyList')} title={t('resellerCompany.title')} />;
  const location = useLocation();
  const companySelected = location.state as { data?: any };
  const companyId = accountResult?.companyId;
  const menuList: Array<MenuItem> = [];

  menuList.push({
    name: t('resellerCompany.optionsList.generalConfig'),
    onClick: () => history.push('/corporate/CompanyConfigurationUpdate'),
    show: accountResult.type === 'supportImplementation' || accountResult.type === 'superAdmin' ? true : false,
  });
  menuList.push({
    name: t('resellerCompany.optionsList.travelReasons'),
    onClick: () => history.push('/corporate/TravelReasons'),
    show: true,
  });
  menuList.push({
    name: t('resellerCompany.optionsList.rejectedReasons'),
    onClick: () => history.push('/corporate/RejectedReasons'),
    show: true,
  });
  menuList.push({
    name: t('resellerCompany.optionsList.breakRulesReasons'),
    onClick: () => history.push('/corporate/BreakRulesReasons'),
    show: true,
  });

  const checkCreditLine = useCallback(async () => {
    if (companyId) {
      const {
        data: { lineOfCreditAvailable },
      } = await getCompanyLineCredit(companyId);
      if (lineOfCreditAvailable) setHasLineCredit(true);
      setLoading(false);
    }
  }, [companyId]);

  useEffect(() => {
    checkCreditLine();
  }, [checkCreditLine, companyId]);

  return loading ? (
    <Loader fullScreen />
  ) : (
    <Container>
      <Desktop>
        <ScreenHeader
          title={t('resellerCompany.title')}
          nameCompany={t('resellerCompany.nameCompany', {company: accountResult.companyName})}
          subtitle={t('resellerCompany.description', {typeCompany: companySelected?.data.isHolding ? t('branchCompany.list.reseller') : t('branchCompany.list.customer')})} 
          right={
            <CloseButton onClick={() => history.replace('/corporate/billingCompanyList')}>
              <CloseIcon />
            </CloseButton>
          }
        />
      </Desktop>

      <Mobile>
        {renderHeader()}
        <Subtitle>{t('resellerCompany.title')}</Subtitle>
      </Mobile>

      <Content>
        <NavigationList list={menuList} />
      </Content>
    </Container>
  );
};

export default ResellerCompany;
